import { ServiceGroup } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface ServiceGroupsState extends EntityState<ServiceGroup> {}

export const serviceGroupsAdapter: EntityAdapter<ServiceGroup> = createEntityAdapter<ServiceGroup>({
  selectId: (serviceGroup: ServiceGroup) => serviceGroup.id
});

export const initialState: ServiceGroupsState = serviceGroupsAdapter.getInitialState({});
export const servicesGroupsFeatureSelector = createFeatureSelector<any>('labourOperations');
export const serviceGroupsSelector = createSelector(
  servicesGroupsFeatureSelector,
  (state: any) => state.serviceGroups
);
export const { selectIds, selectEntities, selectAll, selectTotal } = serviceGroupsAdapter.getSelectors(
  serviceGroupsSelector
);
